export enum MgLocalStorageKeys {
  LETTERS_FILTERS = 'lettersFilters',
  LANG = 'lang',
  TOKEN = 'token',
  ANSWERS_FILTERS = 'answersFilters',
  LAST_USED_OPTION = 'lastUsedOption',
  QUESTIONNAIRE_FILTERS = 'questionnaireFilters',
  REDIRECT_PATH = 'redirectPath',
}
